﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';

function facilityProducts(context) {
  const expandButtons = Array.prototype.slice.call(context.querySelectorAll('button.dt-button'));
  
  function init() {

    expandButtons.forEach(function (expandButton) { 
      expandButton.addEventListener('click', function(e) {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        if (!isExpanded) {
          this.setAttribute('aria-expanded', 'true');
          context.querySelector('#' + this.getAttribute('aria-controls')).removeAttribute('hidden');
        }
        else if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          context.querySelector('#' + this.getAttribute('aria-controls')).setAttribute('hidden', '');
        }
      });
    });
  }

  return {
    init
  };
}

controller.add('facility-products', facilityProducts);